module.exports = "../../static/img/Path.167ecc5.svg";